import { ref } from 'vue'
import { useActivityTracker } from './useActivityTracker'

const showLoadingScreen = ref(false)
const loadingText = ref('Выполняется проверка...')

const { wasActiveInLastHours, getLastActivityTime } = useActivityTracker()

export const useLoadingScreen = () => {
    const checkSomething = async () => {
        return { success: true }
    }

    const performCheck = async () => {
        if (
            (
                !wasActiveInLastHours()
                && !localStorage.getItem(
                    'dailySleepChecker_' + new Date().toISOString().slice(0, 10).split('-').reverse().join('_')
                )
            )
            || localStorage.getItem(
                'dailySleepChecker_' + new Date().toISOString().slice(0, 10).split('-').reverse().join('_')
            ) === 'needCheck'
        ) {
            localStorage.setItem(
                'dailySleepChecker_' + new Date().toISOString().slice(0, 10).split('-').reverse().join('_'),
                'needCheck'
            )
            showLoadingScreen.value = true
        }

        // try {
        //     await new Promise(resolve => setTimeout(resolve, 1000))
        //     const checkResult = await checkSomething()
        //
        //     if (checkResult.success) {
        //         loadingText.value = 'Проверка завершена успешно!'
        //         return true
        //     } else {
        //         loadingText.value = 'Ошибка при проверке'
        //         return false
        //     }
        // } catch (error) {
        //     loadingText.value = 'Произошла ошибка'
        //     return false
        // }
        // loadingText.value = 'QQQ'
    }

    const closeLoadingScreen = (value) => {
        showLoadingScreen.value = false
        localStorage.setItem(
            'dailySleepChecker_' + new Date().toISOString().slice(0, 10).split('-').reverse().join('_'),
            value
        )
    }

    return {
        showLoadingScreen,
        loadingText,
        performCheck,
        closeLoadingScreen
    }
}